import { Button } from "@/components/ui/button";
import { ArrowRight, MapPin } from "lucide-react";
import { COMPANY, MEDIA } from "@/lib/constants";

export const Hero = () => {
    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative min-h-[100svh] w-full overflow-hidden bg-ink"
        >
            <img
                src={MEDIA.hero}
                alt="Wasatch Front waterwise landscape with artificial turf"
                className="absolute inset-0 h-full w-full object-cover"
                loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-ink/30 via-ink/40 to-ink/80" />
            <div className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/30 to-transparent" />

            <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-32 md:pt-40 pb-16 md:pb-24 min-h-[100svh] flex flex-col justify-end">
                <div className="max-w-3xl reveal">
                    <div className="flex items-center gap-3 mb-6 text-bone/80">
                        <MapPin size={14} className="text-terracotta" />
                        <span className="text-xs uppercase tracking-[0.25em] font-semibold">
                            Wasatch Front
                        </span>
                    </div>

                    <h1
                        data-testid="hero-headline"
                        className="font-heading text-5xl md:text-7xl lg:text-[5.5rem] leading-[0.95] tracking-tighter font-medium text-bone"
                    >
                        Your waterwise <br />
                        landscape <span className="text-terracotta italic font-light">subcontractor.</span>
                    </h1>

                    <p className="mt-8 max-w-xl text-base md:text-lg text-bone/85 leading-relaxed font-body">
                        H2No Utah, LLC partners with general contractors and HOA developers across the
                        Wasatch Front to deliver waterwise landscaping, artificial turf, retaining walls,
                        hardscapes, and fencing — on schedule, on spec, and under one PO.
                    </p>

                    <div className="mt-10 flex flex-col sm:flex-row gap-3">
                        <Button
                            data-testid="hero-cta-partner"
                            onClick={() => scrollTo("contact")}
                            className="rounded-none h-12 px-7 bg-terracotta hover:bg-terracotta/90 text-bone text-sm font-semibold tracking-wide group"
                        >
                            Partner With Us
                            <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-1" />
                        </Button>
                        <Button
                            data-testid="hero-cta-capabilities"
                            onClick={() => scrollTo("capabilities")}
                            variant="outline"
                            className="rounded-none h-12 px-7 border-bone/40 bg-transparent text-bone hover:bg-bone hover:text-ink text-sm font-semibold tracking-wide"
                        >
                            View Capabilities
                        </Button>
                    </div>
                </div>

                {/* Bottom stats bar */}
                <div className="relative z-10 mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-4 border-t border-bone/20 pt-6">
                    {[
                        ["6+", "Years on the Front"],
                        ["5+", "GC partnerships"],
                        ["$2M", "Liability insured"],
                        ["48hr", "Bid turnaround"],
                    ].map(([num, label]) => (
                        <div key={label} className="px-2 md:px-4 py-3 border-r last:border-r-0 border-bone/15">
                            <div className="font-heading text-2xl md:text-4xl text-bone font-medium tracking-tight">
                                {num}
                            </div>
                            <div className="mt-1 text-[10px] md:text-xs uppercase tracking-[0.2em] text-bone/60 font-semibold">
                                {label}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
